{
  "auth-process-pages": {
    "login-process-steps": {
      "step-1": {
        "title": "Uživatelské jméno",
        "description": "Váš e-mail nebo telefonní číslo"
      },
      "step-2": {
        "title": "Zabezpečení",
        "description": "Zadejte požadované informace"
      }
    },
    "register-process-steps": {
      "step-1": {
        "title": "Osobní informace",
        "description": "Vyplňte prosím informační formulář"
      },
      "step-2": {
        "title": "Přihlašovací údaje",
        "description": "Nastavte prosím své přihlašovací údaje"
      },
      "step-3": {
        "title": "Ověření účtu",
        "description": "Potvrzovací pin obdržíte e-mailem"
      },
      "step-4": {
        "title": "Vytvořený účet",
        "description": "Váš účet je vytvořen!"
      }
    },
    "meta": {
      "login": {
        "title": "Přihlášení",
        "description": "Přihlášení do služby Beauty Booking"
      },
      "register": {
        "title": "Registrace",
        "description": "Registrace nového účtu"
      }
    }
  }
}
